import CommentParentCard from './CommentParentCard'

export default CommentParentCard
